import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import sensorDataChartType from '../types/sensorDataChart.type';

export const getSensorDataChart = (data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(getSensorDataChartStart());
		let url = URLConstants.GetChartDataForSensor;
		services.post(url, data)
			.then(response => {
				dispatch(getSensorDataChartSuccess(response.data));
			})
			.catch(err => {
				dispatch(getSensorDataChartError(err));
			});
	};
};

const getSensorDataChartStart = () => {
	return {
		type: sensorDataChartType.GET_SENSOR_DATA_CHART_START
	};
};

const getSensorDataChartSuccess = (data: any) => {
	return {
		type: sensorDataChartType.GET_SENSOR_DATA_CHART_SUCCESS,
		payload: data
	};
};

const getSensorDataChartError = (data: any) => {
	return {
		type: sensorDataChartType.GET_SENSOR_DATA_CHART_ERROR,
		payload: data
	};
};

export const resetGetSensorDataChartState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetGetSensorDataChartDispatcher());
	};
};
export const resetGetSensorDataChartSuccessState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetGetSensorDataChartSuccessDispatcher());
	};
};

const resetGetSensorDataChartSuccessDispatcher = () => {
	return {
		type: sensorDataChartType.RESET_SENSOR_DATA_CHART_SUCCESS
	};
};
const resetGetSensorDataChartDispatcher = () => {
	return {
		type: sensorDataChartType.RESET_SENSOR_DATA_CHART
	};
};